// src/components/Footer/Footer.js
import React from 'react';
import { Layout, Row, Col, Divider, Button, Input, notification } from 'antd';
import { 
  PhoneOutlined, 
  MailOutlined, 
  EnvironmentOutlined, 
  SendOutlined,
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
  InstagramOutlined,
  ArrowRightOutlined,
  TruckOutlined,
  SafetyCertificateOutlined,
  ClockCircleOutlined,
  TeamOutlined
} from '@ant-design/icons';
import './Footer.css';

const { Footer: AntFooter } = Layout;
const { TextArea } = Input;

const Footer = () => {
  const [subscriptionEmail, setSubscriptionEmail] = React.useState('');
  
  const handleSubscribe = () => {
    if (!subscriptionEmail) {
      notification.warning({
        message: 'Email Required',
        description: 'Please enter your email address to subscribe.',
      });
      return;
    }
    
    if (!/\S+@\S+\.\S+/.test(subscriptionEmail)) {
      notification.warning({
        message: 'Invalid Email',
        description: 'Please enter a valid email address.',
      });
      return;
    }
    
    notification.success({
      message: 'Subscription Successful',
      description: 'Thank you for subscribing to our newsletter!',
    });
    setSubscriptionEmail('');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AntFooter className="footer">
      <div className="footer-main">
        <div className="container">
          <Row gutter={[40, 30]}>
            {/* Company Info */}
            <Col xs={24} md={8} lg={6}>
              <div className="footer-section">
                <div className="footer-logo">
                  <img src="/logo2.png" alt="NexusFlow" className="footer-logo-image" />
                  {/* <div className="logo-text">
                    <span className="company-name">NEXUSFLOW</span>
                    <span className="company-tagline">Logistics Excellence</span>
                  </div> */}
                </div>
                <p className="footer-description">
                  Premium cargo transportation solutions for businesses across Tanzania. 
                  Delivering reliability, safety, and efficiency in every shipment.
                </p>
                <div className="social-links">
                  <a href="#" className="social-link facebook" aria-label="Facebook">
                    <FacebookOutlined />
                  </a>
                  <a href="#" className="social-link twitter" aria-label="Twitter">
                    <TwitterOutlined />
                  </a>
                  <a href="#" className="social-link linkedin" aria-label="LinkedIn">
                    <LinkedinOutlined />
                  </a>
                  <a href="#" className="social-link instagram" aria-label="Instagram">
                    <InstagramOutlined />
                  </a>
                </div>
              </div>
            </Col>

            {/* Quick Links */}
            <Col xs={12} md={8} lg={4}>
              <div className="footer-section">
                <h4 className="footer-title">Quick Links</h4>
                <ul className="footer-links">
                  <li>
                    <a href="#" onClick={() => scrollToSection('home')} className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Home</span>
                    </a>
                  </li>
                  <li>
                    <a href="#services" onClick={() => scrollToSection('services')} className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Services</span>
                    </a>
                  </li>
                  <li>
                    <a href="#about" onClick={() => scrollToSection('about-us')} className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>About Us</span>
                    </a>
                  </li>
                  <li>
                    <a href="#contact" onClick={() => scrollToSection('contact')} className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Contact</span>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Services */}
            <Col xs={12} md={8} lg={4}>
              <div className="footer-section">
                <h4 className="footer-title">Our Services</h4>
                <ul className="footer-links">
                  <li>
                    <a href="#services" className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Cargo Transportation</span>
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Secure Handling</span>
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Timely Deliveries</span>
                    </a>
                  </li>
                  <li>
                    <a href="#services" className="footer-link">
                      <ArrowRightOutlined className="link-arrow" />
                      <span>Advanced Monitoring</span>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Contact & Newsletter */}
            <Col xs={24} md={16} lg={10}>
              <div className="footer-section">
                <h4 className="footer-title">Stay Updated</h4>
                <p className="footer-newsletter-text">
                  Subscribe to our newsletter for the latest updates and industry insights.
                </p>
                
                <div className="newsletter-form">
                  <Input
                    placeholder="Enter your email address"
                    value={subscriptionEmail}
                    onChange={(e) => setSubscriptionEmail(e.target.value)}
                    size="large"
                    className="newsletter-input"
                    onPressEnter={handleSubscribe}
                  />
                  <Button 
                    type="primary" 
                    size="large" 
                    icon={<SendOutlined />}
                    onClick={handleSubscribe}
                    className="newsletter-btn"
                  >
                    Subscribe
                  </Button>
                </div>

                <Divider className="footer-divider" />
                
                <h4 className="footer-title">Contact Info</h4>
                <div className="contact-info">
                  <div className="contact-item">
                    <PhoneOutlined className="contact-icon" />
                    <span>+255 766 764 387</span>
                  </div>
                  <div className="contact-item">
                    <PhoneOutlined className="contact-icon" />
                    <span>+255 772 556 030</span>
                  </div>
                  <div className="contact-item">
                    <MailOutlined className="contact-icon" />
                    <span>info@nexusflow.co.tz</span>
                  </div>
                  <div className="contact-item">
                    <EnvironmentOutlined className="contact-icon" />
                    <span>Tiger Tower, Togo Street, Kinondoni, Dar es Salaam</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <Row align="middle" justify="space-between">
            <Col xs={24} md={12}>
              <p className="copyright">
                © {new Date().getFullYear()} NexusFlow Co. Ltd. All rights reserved.
              </p>
            </Col>
            <Col xs={24} md={12}>
              <div className="footer-bottom-links">
                <a href="#" className="bottom-link">Privacy Policy</a>
                <span className="link-separator">•</span>
                <a href="#" className="bottom-link">Terms of Service</a>
                <span className="link-separator">•</span>
                <a href="#" className="bottom-link">Cookie Policy</a>
              </div>
            </Col>
            <Col xs={24}>
              <p className="developer-credit">
                Designed and Developed by <span className="jcodes-text">Jcodes Technologies</span>
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;